














import { Component, Vue, Prop } from 'vue-property-decorator';
import MeteorIcon from './icons/MeteorIcon.vue';
import CheckIcon from './icons/CheckIcon.vue';

@Component({
  components: {
    MeteorIcon,
    CheckIcon,
  },
})
export default class XPBadge extends Vue {
  @Prop({ required: true, type: Number }) private xp!: number;
  @Prop({ type: Boolean, default: false }) private showPlusSign?: boolean;
  @Prop({ type: Boolean, default: false }) private hasEarned?: boolean;

  private get xpDisplay(): string {
    const prefix = this.showPlusSign ? '+' : '';
    return `${prefix}${this.xp} XP`;
  }

  private get meteorColor(): string {
    if (this.hasEarned) {
      if (this.xp === 0) {
        return '#FFF';
      }

      return '#179E7E';
    }

    return '#FFF';
  }

  private get meteorStrokeAndTrailColor(): string {
    if (this.hasEarned) {
      if (this.xp === 0) {
        return '#B7B7B7';
      }

      return '#FFF';
    }

    return '#179E7E';
  }
}
